// src/components/Industries.js
import React from 'react';
import { useInView } from 'react-intersection-observer';
import './industries.css';

const industries = [
    {
        title: "Hospitality & Food Services",
        items: [

            "Hotels & Restaurants",
            "Flight Catering units",
            "Cloud Kitchens",
            "Catering Units",
            "Industrial Kitchens",

        ]
    },
    {
        title: "Meat & Poultry",
        items: [
            "Meat Plants",
            "Slaughter House",
            "Meat Distributors",
            "Meat Exporters",
            "Poultry Business",
            "Ready to Eat /Cook Frozen Food (Non Veg)"

        ]
    },
    {
        title: "Pharma & Biotech",
        items: [
            "Pharma Product Manufacturers",
            "Vaccine Manufacturers",
            "Biotech Companies",
            "Importers & Exporters",
            "Warehousing ",
            "Hospitals"       
        ]
    },
    {
        title: "Chemical",
        items: [
            "Chemical Storage Warehousing",
            "Multi Chamber Multi temperature Zones"
                  
        ]
    },
    {
        title: "Warehouse & Logistics ",
        items: [

            "Temperature Controlled Warehouses",
            "Pharma & Biotech",
            "Chocolates & Confectionary Items",
            "Food Products",
            "Healthcare",
            "Wine",
            "Chemicals",                 
        ]
    },
    {
        title: "Food Processing Industries ",
        items: [

            "Frozen Food Manufacturers",
            "Fresh Fruits & Vegetables",
            "Processed Food Companies",
            "Dairy Product Manufacturers",
            "Confectionary Plants",
            "Juice Plants",
            "Other Food Processing Companies "              
        ]
    },
    {
        title: "Testing Labs / R & D Centres ",
        items: [

            "Stability Chambers for R & D Activities",
            "Blood Banks",
            "Plasma Storage",
            "Biological Samples Storage"           
        ]
    },
    {
        title: "Food Processing Industries ",
        items: [

            "Frozen Food Manufacturers",
            "Fresh Fruits & Vegetables",
            "Processed Food Companies",
            "Dairy Product Manufacturers",
            "Confectionary Plants",
            "Juice Plants",
            "Other Food Processing Companies "              
        ]
    },
    {
        title: "Testing Labs / R & D Centres ",
        items: [

            "Stability Chambers for R & D Activities",
            "Blood Banks",
            "Plasma Storage",
            "Biological Samples Storage"            
        ]
    },
    {
    title: "E-Commerce & Retail",
    items: [

        "Online Groceries ( Food Products)",
        "Online Food Deliveries ",
        "Food & Beverage "
                   
    ]
},
{
    title: "Cold Chain Service Providers ",
    items: [

        "Cold Chain Service Providers",
        "Cold Storage Owners",
        "Distribution Centres",
        "Refrigerated Warehouse",
        "Refrigerated Transport Logistics "
        
                   
    ]
},
{
    title: "Fresh Fruits & Vegetables",
    items: [

        "Fruits & Vegetables Producers & Farmers",
        "Fruits & Vegetables Merchants",
        "Banana & Mango Ripening Units",
        "Exporters",
        "Farm Level Cold Chain ",
        "Grapes Exporters"
        
                   
    ]
},
{
    title: "Special Application HVACR Projects",
    items: [

        "Precision Airconditioning Projects",
        "Testing Labs",
        "R & D Centres",
        "Data Centres",
        "Process Halls & Production Centres"       
                   
    ]
},
{
    title: "Seeds",
    items: [

        "Seed Growers",
        "Exporters",
        "Warehousing"   
                   
    ]
},

];

const Industries = () => {
    return (
        <section className="industries-container">
            <h2 className="industries-title">Industries We Serve</h2>
            <div className="industries-grid">
                {industries.map((industry, index) => (
                    <IndustryItem
                        key={index}
                        title={industry.title}
                        items={industry.items}
                        index={index}
                    />
                ))}
            </div>
        </section>
    );
};

const IndustryItem = ({ title, items, index }) => {
    const { ref, inView } = useInView({
        triggerOnce: false, // Allows animation to trigger multiple times
        threshold: 0.1
    });

    return (
        <div
            ref={ref}
            className={`industries-item ${inView ? 'in-view' : ''}`}
            style={{ '--order': index + 1 }}
        >
            <h3>{title}</h3>
            {items.length > 0 && (
                <ul className="industries-list">
                    {items.map((item, subIndex) => (
                        <li key={subIndex}>{item}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Industries;
